export const getLocalStorageItem = (key) => {
  return localStorage.getItem(key);
};

export const setLocalStorageItem = (key, value) => {
  return localStorage.setItem(key, value);
};

export const clearLocalStorage = () => {
  localStorage.clear();
};
